export const firebaseConfig = {
  apiKey: `AIzaSyCxMZeGpUleIK7ZB2rFGRsk_dla3QUsOBY`,
  authDomain: `wakeflow-tokens.firebaseapp.com`,
  projectId: `wakeflow-tokens`,
  storageBucket: `wakeflow-tokens.appspot.com`,
  messagingSenderId: `854602909651`,
  appId: `1:854602909651:web:d5befd1f3c1bf84a3f5126`,
  measurementId: `G-B6SPK9F5EM`,
}
